import {isEmptyString} from "./stringUtils";

export const getQueryParams = (obj) => {
    const filterData = Object.keys(obj).filter(ele => !isEmptyString(obj[ele]));
    return filterData && filterData.length? '?' + filterData.reduce((acc, ele) => {
        return [...acc, `${ele}=${obj[ele]}`];
    }, []).join('&') : ''
};
